import { createSlice } from "@reduxjs/toolkit"
import {
  addNewRole,
  deleteRole,
  fetchRoles,
  getRoleDetails,
  updateRoleDetails,
  updateRoleStatus,
} from "store/actions/rolesAction"

const initialState = {
  loading: true,
  error: null,
  isLoading: false,
  rolesList: [],
  roleDetails: {},
  isUpdating: false,
  isUpdateSuccess: false,
  isUpdateFailed: false,
  actionType: null,
  message: null,
  itemsPerPage: 10,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
}

const usersSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH ROLES BUILDER
    builder
      .addCase(fetchRoles.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false
        const { status } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.rolesList = action.payload.data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
          state.error = null
        }
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false
        state.rolesList = []
        state.error = action.payload.msg
      })
    // UPDATE ROLES STATUS BUILDER
    builder
      .addCase(updateRoleStatus.pending, state => {
        state.isUpdating = true
        state.error = null
        state.isUpdateSuccess = false
        state.actionType = null
      })
      .addCase(updateRoleStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.rolesList = state.rolesList.map(role =>
            role._id === id ? { ...role, status: Number(status) } : role
          )
          state.message = action.payload.msg
          state.isUpdateSuccess = true
          state.actionType = "ROLE_UPDATE_SUCCESS"
        } else {
          state.actionType = "ROLE_UPDATE_FAILED"
          state.erorr = action.payload.msg
        }
      })
      .addCase(updateRoleStatus.rejected, (state, action) => {
        state.isUpdating = false
        state.error = action.payload.msg
        state.isUpdateFailed = true
      })
    // ADD ROLE BUILDER
    builder
      .addCase(addNewRole.pending, state => {
        // state.error = null
        state.isLoading = true
        // state.actionType = null
        // state.roleDetails = {}
      })
      .addCase(addNewRole.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          // state.error = null
          // state.roleDetails = action.payload.data
          // state.actionType = "ADDED_ROLE_SUCCESS"
          // state.message = action.payload.msg
          action.meta.arg.navigate("/roles")
        } else {
          // state.actionType = "ADDED_ROLE_FAILED"
          // state.error = action.payload.msg
        }
      })
      .addCase(addNewRole.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload.msg
        state.actionType = "FAILED_ADD_ROLE"
      })
    // UPDATE ROLE BUILDER
    builder
      .addCase(getRoleDetails.pending, state => {
        state.error = null
        state.loading = true
        state.actionType = null
      })
      .addCase(getRoleDetails.fulfilled, (state, action) => {
        const { status, data, msg } = action.payload
        state.loading = false
        if (status) {
          state.error = null
          state.roleDetails = data
          state.actionType = "ROLE_DETAILS_SUCCESS_FETCHED"
          state.message = msg
        } else {
          state.actionType = "ROLE_DETAILS_FAILED_FETCHED"
          state.error = msg
        }
      })
      .addCase(getRoleDetails.rejected, (state, action) => {
        state.isLoading = false
        state.error = ""
        state.actionType = "FAILED_ADD_ROLE"
      })
    // EDIT ROLE DETAILS
    builder
      .addCase(updateRoleDetails.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
      })
      .addCase(updateRoleDetails.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        state.isLoading = false
        if (status) {
          state.error = null
          state.actionType = "ROLE_UPDATED_SUCCESS"
          state.message = msg
        } else {
          state.actionType = "ROLE_UPDATED_FAILED"
          state.error = msg
        }
      })
      .addCase(updateRoleDetails.rejected, (state, action) => {
        state.isLoading = false
      })
    // DELETE ROLE
    builder
      .addCase(deleteRole.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id, setShowDeleteModal } = action.meta.arg
        state.isLoading = false
        if (status) {
          // const updatedData = state.rolesList.filter(item => item._id !== id)
          state.rolesList = state.rolesList.filter(item => item._id !== id)
          // console.log(updatedData)
          setShowDeleteModal(false)
          state.error = null
          state.actionType = "ROLE_DELETE_SUCCESS"
          state.message = msg
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        } else {
          state.actionType = "ROLE_DELETE_FAILED"
          state.error = msg
        }
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
